import React from 'react';
import styled from '@emotion/styled';
import { palette, radius, spacing, typography } from '../../style-utils/theme';
import { shimmerLoop, skeletonBackground } from '../../style-utils/motion';

const Skeleton = styled.div`
  display: grid;
  gap: ${spacing.sm};
  width: 100%;
  padding: ${spacing.md};
  border: 1px solid ${palette.line};
  border-radius: ${radius.md};
  background: ${palette.surface};
`;

const Label = styled.span`
  color: ${palette.slate};
  font-family: ${typography.ui};
  font-size: ${typography.size.xs}px;
`;

const Row = styled.span<{ $width: string }>`
  display: block;
  width: ${({ $width }) => $width};
  max-width: 100%;
  height: ${spacing.sm};
  border-radius: ${radius.pill};
  ${skeletonBackground};
  ${shimmerLoop}
`;

interface ReportSkeletonProps {
  label?: string;
}

export const ReportSkeleton: React.FC<ReportSkeletonProps> = ({
  label = 'Loading report',
}) => (
  <Skeleton role="status" aria-live="polite" aria-busy="true">
    <Label>{label}</Label>
    <Row $width="42%" aria-hidden="true" />
    <Row $width="88%" aria-hidden="true" />
    <Row $width="76%" aria-hidden="true" />
    <Row $width="64%" aria-hidden="true" />
  </Skeleton>
);
